import { HashLink } from "react-router-hash-link";


export default function Footer() {
  return (
    <footer className="w-full mt-20 py-12 bg-black/40 backdrop-blur-sm border-t border-neonTurquoise">
      <div className="max-w-6xl mx-auto px-4 md:px-6 flex flex-col md:flex-row justify-between text-grayText gap-12">

        {/* Brand & About */}
        <div className="flex-1 text-center md:text-left">
          <h3 className="text-white text-3xl font-bold mb-6">Kalon Fitness</h3>
          <p className="text-base mb-6">
            Train like a high performer. Endurance, strength, sports performance, and nutrition coaching designed for results.
          </p>
          <div className="flex justify-center md:justify-start gap-6 text-neonTurquoise text-3xl">
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
          </div>
        </div>

        {/* Programs */}
        <div className="flex-1 text-center md:text-left">
          <h4 className="text-white font-bold text-xl mb-5">Programs</h4>
          <ul className="space-y-3 text-lg">
            <li>
              <HashLink smooth to="/programs#endurance_programs" 
              scroll={el => el.scrollIntoView({ behavior: "smooth", block: "start" })}
              className="hover:text-neonTurquoise transition-colors">Endurance</HashLink>
            </li>
            <li>
              <HashLink smooth to="/programs#strength_program" 
              scroll= {el => el.scrollIntoView({behavior: "smooth", block: "start"})} 
              className="hover:text-neonTurquoise transition-colors">Strength & Aesthetic</HashLink>
            </li>
            <li>
              <HashLink smooth 
              to="/programs#sports_program" 
              scroll= {el => el.scrollIntoView({behavior: "smooth", block: "start"})}
              className="hover:text-neonTurquoise transition-colors">Sports Performance</HashLink>
            </li>
            <li>
              <a href="/programs" className="hover:text-neonTurquoise transition-colors">All Programs</a>
            </li>
          </ul>
        </div>

        {/* Resources */}
        <div className="flex-1 text-center md:text-left">
          <h4 className="text-white font-bold text-xl mb-5">Resources</h4>
          <ul className="space-y-3 text-lg">
            <li>
              <a href="/blog" className="hover:text-neonTurquoise transition-colors">Blog</a>
            </li>
            <li>
              <a href="/my-journey" className="hover:text-neonTurquoise transition-colors">My Journey</a>
            </li>
            <li>
              <a href="/contact" className="hover:text-neonTurquoise transition-colors">Contact</a>
            </li>
            <li>
              <a href="/apply-now" className="hover:text-neonTurquoise transition-colors">Apply Now</a>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="flex-1 text-center md:text-left">
          <h4 className="text-white font-bold text-xl mb-5">Contact</h4>
          <ul className="space-y-3 text-lg">
            <li>Email: <a href="mailto:info@kalonfitness.com" className="hover:text-neonTurquoise transition-colors">info@kalonfitness.com</a></li>
            <li>Phone: <a href="tel:+1234567890" className="hover:text-neonTurquoise transition-colors">+1 234 567 890</a></li>
            <li>Location: Denver, CO</li>
          </ul>
        </div>

      </div>

      {/* Footer Bottom */}
      <div className="mt-12 text-center text-gray-300 text-base">
        © {new Date().getFullYear()} Kalon Fitness. All rights reserved.
      </div>
    </footer>
  );
}
